module.exports = __webpack_public_path__ + "static/media/Musketeer.59cd14e9.jpg";